module.exports = function() {
  return new Worker(__webpack_public_path__ + "b3f48a89c1aeec84f53c.worker.js");
};